<template>
  <div id="app">
      <ViewPage/>
  </div>
</template>

<script>
import ViewPage from './layouts/ViewPage.vue';
import build from '@/api/example'

export default {
  name: 'App',
  components: {
    ViewPage,
  },
  data() {
    return {
      checkMobile: false
    }
  },
  methods: {
    isMobile() {
      var user = navigator.userAgent;

      // console.log(user)

      if( user.indexOf("iPhone") > -1 
          || user.indexOf("Android") > -1 
          || user.indexOf("iPad") > -1
          || user.indexOf("iPod") > -1
      ) {
          this.checkMobile = true;
      }
    },
    checkLogin() {
      build.get('/mer/api/member')
      .then(res => { //인증된 사용자가 정보가 서버에 있을 경우
        this.$store.state.isLogin = true;

        if(res.data.userSe === 'ADMIN') {
          this.$store.state.isAdmin = true;
        }

        if(res.data.userSe === 'BSN') {
          this.$store.state.isBusiness = true;
        }

        this.$store.state.loginMemberIndex = res.data.id
      })
      .catch(err => { //인증된 사용자가 정보가 서버에 없을 경우
        this.$store.state.isLogin = false;
        this.$store.state.isAdmin = false;
        this.$store.state.isBusiness = false;
        console.log(err);
      });
    },
    getClientId() {
      this.$store.dispatch('getNaverClientId');

      console.log("dispatch");
    },
  },
  mounted() {

    console.log("firstPopupCheck: " + this.$store.state.popupCheck);
    
    this.checkLogin();

    // this.getClientId();

  },
}
</script>

<style>

  body {
    overflow-y: auto !important;
    overflow-x: hidden;
  }

  /* body.el-popup-parent--hidden {
    overflow-y: hidden !important;
  } */

  h1 {
    font: revert !important;
  }

  h2 {
    font: revert !important;
  }

  h3 {
    font: revert !important;
  }

  h4 {
    font: revert !important;
  }

  h5 {
    font: revert !important;
  }

  tr {
    font: revert !important;
  }

  td {
    font: revert !important;
  }

  ul {
    list-style: revert;
  }
  
  ol {
    list-style: revert;
  }

  /* li {
    font: revert !important;
  }

  div {
    font: revert !important;
  } */

  i {
    font: revert !important;
  }

  /* p {
    font: revert !important;
  } */
  
  em {
    font: revert !important;
  }

</style>
